export default function StatCard({ label, value, sub, icon: Icon, accent = "#F0B90B", testid }) {
  return (
    <div
      data-testid={testid}
      className="rounded-lg border border-[#2A2E39] bg-[#131722] p-4 transition-colors hover:border-[#3a3f4d]"
    >
      <div className="flex items-center justify-between">
        <span className="text-[11px] font-medium uppercase tracking-wider text-[#848E9C]">{label}</span>
        {Icon && <Icon className="h-4 w-4" style={{ color: accent }} />}
      </div>
      <div className="mt-2 font-mono text-xl font-semibold" style={{ color: accent }}>
        {value}
      </div>
      {sub && <div className="mt-1 text-xs text-[#5E6673]">{sub}</div>}
    </div>
  );
}
